import { render, staticRenderFns } from "./NombreEtablissementParTypeParLocalisation.vue?vue&type=template&id=07056cdd&"
import script from "./NombreEtablissementParTypeParLocalisation.vue?vue&type=script&lang=js&"
export * from "./NombreEtablissementParTypeParLocalisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports